module.exports = __webpack_public_path__ + "media/images/eesify-5acce91d5a2a92481ae778ab4e4916c6.png";